import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { install as dvBoxLayoutExtensionInstall } from './dvBoxLayout';

export function install(registers: EChartsExtensionInstallRegisters) {
  dvBoxLayoutExtensionInstall(registers);
}
